import type { IdCompanyDto, UserDto } from '@/services/ws-permissions/src/main/resources/rest-api';
import { getCurrentUser } from '@/services/ws-permissions/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useLazyRequest } from '@/js/libs/use-request';

import { ErrorCode } from 'src/types.ts';
import { SELECTED_COMPANY_HEADER_NAME } from '../../../constants.ts';

type UserParams = {
  selectedCompanyId?: IdCompanyDto;
};

type GetIdentity = (userParams?: UserParams) => Promise<UserDto>;

export const useGetIdentity = (): GetIdentity => {
  const getCurrentUserRequest = useLazyRequest({
    apiMethod: getCurrentUser,
    // Runs every load to the end: loads with different params may run in parallel.
    cancelPreviousRequests: false,
    // Skips the interceptors for forbidden and not-found failures: a failed load opens none of their status pages.
    ignoreErrors: [ErrorCode.Forbidden, ErrorCode.NotFound],
    // Builds the identity from the params alone, without the selected-company header the interceptors add.
    ignoreHeaders: [SELECTED_COMPANY_HEADER_NAME],
  });

  // Leaves the outcome of every load, its failure included, to the caller.
  return useCallbackRef<GetIdentity>((userParams = {}) =>
    getCurrentUserRequest.load(userParams, { silent: true }).then((response) => response.data),
  );
};
